// --- Libraries
import fs from 'fs';
import path from 'path';
// --- Modules
import pkg from '../package';

const sdkVersion = pkg.version;
const userAgent = `roar-sdk ${sdkVersion} (node ${process.version}-${process.arch}-${process.platform}; OpenSSL ${process.versions.openssl})`;

export default {
  version: sdkVersion,
  userAgent: userAgent,
  inspector: process.env.NODE_ENV === 'prod' ? fs.existsSync(path.resolve('/scanner/roar-config.json')) ? require(path.resolve('/scanner/roar-config.json')) : require(path.resolve('./roar-config.json')) : require(path.resolve('./roar-config.json')),
  apiURL: () => {
    if (process.env.NODE_ENV !== 'test') {
      return `https://${process.env.API_URL}/api/v1.0`;
    } else {
      return 'https://sandbox.roar.liongard.com/api/v1.0';
    }
  }
};
